import script from "./PropertyCadastralAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCadastralAudit.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCadastralAudit.vue?vue&type=style&index=0&id=628c665c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628c665c"]])

export default __exports__